import { IListResource } from './Resource';

import {
  DatabasesQueryByIdsNodes,
} from '@tableau/data-catalog-client-components';
import { DatabasesByIdsGraphQLResourceQuery } from '../../catalog/fetchers/DatabasesByIdsGraphQLResourceQuery';

/*
 * Not the most ideal way to deal with graphql calls since we need a new
 * resource for each new query.
 *
 * Consider refactoring this / rethinking a new way to make this more elegant!
 * Unfortunately tight on time to get this in for 2019.3
 */
export class DatabasesByIds implements IListResource<DatabasesQueryByIdsNodes> {

  private allQuery: DatabasesByIdsGraphQLResourceQuery;

  constructor() {
    this.allQuery = new DatabasesByIdsGraphQLResourceQuery();
  }

  public all(): DatabasesByIdsGraphQLResourceQuery {
    return this.allQuery;
  }
}

export const databasesByIds = new DatabasesByIds();
